import {
  FETCH_DCM_LANDING_PAGES,
  ADD_CUSTOM_LANDING_PAGE,
  CLEAR_LANDING_PAGES
} from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";
import { normalizeDataByField } from "../utils/normalize";

const initialState = { isLoading: false, byId: {}, allIds: [] };

export const dcmLandingPages = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DCM_LANDING_PAGES:
      switch (action.status) {
        case SUCCESS:
          let { byId, allIds } = normalizeDataByField(action.data, "id");
          return { isLoading: false, byId, allIds };
        case FAILURE:
          return {
            isLoading: false,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        case PENDING:
          return {
            isLoading: true,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        default:
          return state;
      }
    case ADD_CUSTOM_LANDING_PAGE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.landingPage.id]: {
            ...action.landingPage
          }
        },
        allIds: [...state.allIds, action.landingPage.id]
      };
    case CLEAR_LANDING_PAGES:
      return {
        ...initialState
      }
    default:
      return state;
  }
};
